export default "__VITE_ASSET__DBVhYinV__"